// view/holdRepeat.js — a button that repeats while it is held, and faster the longer (plan
// bugfix_2026-10-14_polishing-patch, phase video-skip; boss 192: skip in the media controls).
//
//   bindHoldRepeat(button, { onStep, onStart?, onEnd? }) → { destroy }
//
// A press calls onStart() and onStep(1) at once. Still held after `delay` ms, it repeats every `interval` ms, the step
// growing by 1 up to `maxStep` (1, 2, 3, … 10, 10, …). Releasing or leaving the button stops it and calls onEnd() (the
// media controls pause the media for the hold and resume it after). The keyboard (Enter / Space make a click with
// detail 0) gives one step of 1, without onStart/onEnd. The caller decides what a step means (the media controls:
// seconds).

import { createDisposers } from '../core/disposers.js';

export function bindHoldRepeat(button, { onStep, onStart = () => {}, onEnd = () => {}, delay = 400, interval = 250, maxStep = 10 }) {
    const disposers = createDisposers();
    const on = (node, ev, fn) => { node.addEventListener(ev, fn); disposers.add(() => node.removeEventListener(ev, fn)); };

    let delayTimer = null;
    let repeatTimer = null;
    let holding = false;

    const clearTimers = () => {
        clearTimeout(delayTimer);
        clearInterval(repeatTimer);
        delayTimer = null;
        repeatTimer = null;
    };
    const stop = () => {
        clearTimers();
        if (holding) {
            holding = false;
            onEnd();
        }
    };

    on(button, 'pointerdown', (ev) => {
        if (ev.button !== 0) { return; }
        stop();
        holding = true;
        onStart();
        let step = 1;
        onStep(step);
        delayTimer = setTimeout(() => {
            repeatTimer = setInterval(() => {
                step = Math.min(maxStep, step + 1);
                onStep(step);
            }, interval);
        }, delay);
    });
    on(button, 'pointerup', stop);
    on(button, 'pointerleave', stop);
    on(button, 'pointercancel', stop);
    // A long touch press would open the context menu instead of repeating.
    on(button, 'contextmenu', (ev) => ev.preventDefault());
    // Mouse and touch are handled on pointerdown; only a keyboard click (detail 0) steps here.
    on(button, 'click', (ev) => { if (ev.detail === 0) { onStep(1); } });

    // destroy ends a running hold WITHOUT onEnd: the controls are being torn down, nothing should resume playing.
    disposers.add(() => { clearTimers(); holding = false; });
    return { destroy() { disposers.dispose(); } };
}
